import { connect } from 'react-redux';

import PrintReport from './PrintReport.js';

const isActive = a => a.active === true;

const mapStateToProps = state => {
  const activeServer = state.servers.servers.find(isActive);
  return {
    viewportData: state.viewports.viewportSpecificData,
    context: state.ui.heatmapContext,
    server: activeServer,
  };
};

const ConnectedPrintReport = connect(
  mapStateToProps,
  null
)(PrintReport);

export default ConnectedPrintReport;
